import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpErrorResponse,
    HttpStatusCode
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppState } from '../../services/app.service';
import { NotificationService } from '../../notification/services/notification.service';
import { showToast } from '../models/context';
import { AzureLoggerService } from '../../services/azureLoggerService';

@Injectable()
export class ErrorsInterceptor implements HttpInterceptor {
    constructor(
        private notificationService: NotificationService,
        private appState: AppState,
        private azureLoggerService: AzureLoggerService) {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(request).pipe(
            catchError((errorResponse: HttpErrorResponse) => {
                if (errorResponse.status === HttpStatusCode.Unauthorized) {
                    this.appState.logOut();
                }

                if (errorResponse.error instanceof ProgressEvent) {
                    if (!navigator.onLine) {
                        this.notificationService.showErrorNotificationByKey('general-errors.no-internet-connection');
                    } else {
                        this.notificationService.showWarningNotificationByKey('general-errors.server-not-respond');
                    }
                }

                if (this.isServerError(errorResponse)) {
                    if (errorResponse.error instanceof ArrayBuffer) {
                        const error = String.fromCharCode.apply(
                            null,
                            (new Uint8Array(errorResponse.error) as any)
                        );
                        if (error) {
                            Object.assign(errorResponse, { error })
                        }
                    }
                    if (request.context.get(showToast)) {
                        this.notificationService.showErrorNotificationByKeyAndCorrelationId(errorResponse.error);
                    }

                    this.azureLoggerService.logException(errorResponse, 3);
                    console.error(`Error correlation ID: ${errorResponse.error}`);
                }

                return throwError(() => errorResponse);
            })
        );
    }

    private isServerError(errorResponse: HttpErrorResponse) {
        return errorResponse &&
            errorResponse.status >= HttpStatusCode.InternalServerError &&
            errorResponse.status <= HttpStatusCode.NetworkAuthenticationRequired;
    }
}
